import React, {useEffect} from 'react';
import { useSelector,useDispatch } from 'react-redux';
import {getClasses} from "../../../store/class/class.actions"
import {getSubjects} from "../../../store/subject/subject.actions"
import {getTutors} from "../../../store/tutor/tutor.actions"
import {Table,Button} from 'react-bootstrap';

let today = new Date()
let lastMonth = new Date(today)
lastMonth.setDate(today.getDate() - 30)

const StudentPastClasses = () => {
    const dispatch = useDispatch() 
    const {user} = useSelector((state) => state.auth)
    const {classes} = useSelector((state) => state.class)
    const {subjects} = useSelector((state) => state.subject)
    const {tutors} = useSelector((state) => state.tutor)
    useEffect(() => {
        dispatch(getClasses({filter:{studentIds:user._id, end:{"$lte":today.toISOString()} , start:{"$gte": lastMonth}}, selection:{}}))
        dispatch(getSubjects({filter:{},selection:{}}))
        dispatch(getTutors({filter:{'status':'Activo'}, selection:{}}))
    }, [])
    let newClasses = []
    for (const currentClass of classes){
        let newClass = {...currentClass}
        if(newClass.studentIds.includes(user._id)){
            for (const tutor of tutors){
                if (tutor._id == newClass.tutorId){
                    newClass["tutorName"] = tutor['name'].split(" ")[0] + " " + tutor['surname'].split(" ")[0]
                }
            }
            for (const subject of subjects){
                if (subject._id == newClass.subjectId){
                    newClass["subjectName"] = subject['name']
                }
            }
            newClasses.push(newClass)
        }
    }
    newClasses = newClasses.slice().sort((a,b) => new Date(b.start) -new Date(a.start))
    return(
        <>
            <h3>Clases Pasadas (Últimos 30 días)</h3>
            <br/>
            
            <Table striped bordered hover style={{ width: '80%','margin-left':'auto','margin-right':'auto' }}>
                <thead>
                <tr>
                <th>Fecha</th>
                <th>Comienzo</th>
                <th>Final</th>
                <th>Tutor</th>
                <th>Materia</th>
                <th>Rating</th>
                <th>Feedback</th>
                </tr>
                </thead>
                <tbody>
                {newClasses.map((currentClass,id) => {
                    let start = new Date(currentClass.start)
                    let month = start.getMonth().toString().padStart(2, '0')
                    month = Number(month) + 1
                    let day = `${start.getDate().toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}`
                    let end = new Date(currentClass.end)
                    start = `${start.getHours()}:${start.getMinutes().toString().padStart(2, '0')}`
                    end = `${end.getHours()}:${end.getMinutes().toString().padStart(2, '0')}`
                    let feedback = ""
                    let rating = ""
                    let sent = currentClass.individualStudentFeedback.filter(feedback => feedback.sender === user._id).length > 0;
                    if (!sent){
                        feedback = <Button style={{backgroundColor:"rgba(10, 181, 145, 1)", borderColor:"rgba(10, 181, 145, 1)"}}><a href={`${window.location.origin}/studentfeedback?id=${currentClass._id}`} target="_blank" style={{color:"rgb(255,255,255)"}}>Feedback</a></Button>
                        rating = "N/A"
                    }else{
                        feedback = "Enviado"
                        rating = `${currentClass.rating}/10`
                    }
                    return(
                        <tr>
                            <td>{day}</td>
                            <td>{start}</td>
                            <td>{end}</td>
                            <td>{currentClass.tutorName}</td>
                            <td>{currentClass.subjectName}</td>
                            <td>{rating}</td>
                            <td>{feedback}</td>
                        </tr>
                    )
                })}
                </tbody>
            </Table>
        </>
    )
}

export default StudentPastClasses
